
function copy(target) {
  global.navigator.clipboard.writeText(target)
}

export default copy
